import { render, staticRenderFns } from "./ordertrack.vue?vue&type=template&id=2d71685c&scoped=true&"
import script from "./ordertrack.vue?vue&type=script&lang=tsx&"
export * from "./ordertrack.vue?vue&type=script&lang=tsx&"
import style0 from "./ordertrack.vue?vue&type=style&index=0&id=2d71685c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d71685c",
  null
  
)

export default component.exports